/*
 * File: cell-switch.ts
 * File Created: 2023-12-19 06:50:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 11:19:29
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import {
    BaseTableBodyCell,
    ITableBodyCellData,
} from "../../../core/lib/base-table-body-cell/base-table-body-cell";
import { ISwitchData } from "@root/components/inputs/input-switch/input-switch";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiSort: true,
    uiSearch: true,
})
export default class CellSwitch extends BaseTableBodyCell {
    @Prop({ type: Object, required: false })
    declare data: (ISwitchData & ITableBodyCellData) | undefined;
}
